import axios from 'axios';

export const GET_VERIFICATION_VIEW_DATA_BEGIN = 'GET_VERIFICATION_VIEW_DATA_BEGIN';
export const GET_VERIFICATION_VIEW_DATA_SUCCESS = 'GET_VERIFICATION_VIEW_DATA_SUCCESS';
export const GET_VERIFICATION_VIEW_DATA_FAILURE = 'GET_VERIFICATION_VIEW_DATA_FAILURE';
export const GET_VERIFICATION_VIEW_DATA_LICENCE_SUSPENDED = 'GET_VERIFICATION_VIEW_DATA_LICENCE_SUSPENDED';

export const getVerificationViewDataBegin = () => ({
    type: GET_VERIFICATION_VIEW_DATA_BEGIN
});

export const getVerificationViewDataSuccess = (value) => ({
    type: GET_VERIFICATION_VIEW_DATA_SUCCESS,
    payload: value
});

export const getVerificationViewDataFailure = (error) => ({
    type: GET_VERIFICATION_VIEW_DATA_FAILURE,
    payload: error
});

export const getVerificationViewDataLicenceSuspended = () => ({
    type: GET_VERIFICATION_VIEW_DATA_LICENCE_SUSPENDED
});

export const getVerificationViewData = (webappurlPortal, accessToken, token, licenceType) => {
    return dispatch => {
        const options = {
            headers: {
                'Authorization': 'Bearer ' + accessToken,
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        };

        const requestBody = {
            verificationToken: token
        }

        dispatch(getVerificationViewDataBegin());
        //TODO: Figure out where to store URL
        
        return axios.post(`${webappurlPortal}/api/licence/flightcrew/verificationview/${licenceType}/v1`, requestBody, options)
            .then(response => {
                if (response.data.wasSuccessful) {
                    return dispatch(getVerificationViewDataSuccess(response.data));
                }
                else {
                    return dispatch(getVerificationViewDataFailure('System error'));
                }
            })
            .catch(error => {
                return dispatch(getVerificationViewDataFailure(error.response ? error.response.data.errors : error));
            });
    };
};